const PropTypes = require('prop-types');
// @ vendors
const React = require('react');

// @ helpers
const { getFinalTitle } = require('core/i18n').i18n;

// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');

// @ constants
const { BROKER_TRUNCATED_BREADCRUMB_ARROW_LENGTH, BROKER_TRUNCATED_BREADCRUMB_MAX_SIZE } = require('constants/index');

class BrokerTruncatedBreadcrumb extends React.Component {

    getCharLength(links, arrowLength){
        let count = 0
        for (const link of links){
            count += link.text.length;
        }
        count += arrowLength * (links.length - 1);
        return count;
    }

    truncateBreadcrumbs(links, arrowLength, maxSize){
        const totalLenght = this.getCharLength(links, arrowLength);
        if (totalLenght > maxSize){
            const linksLength = links.length - 1;
            const shortlinks = links.map((link, index)=>{
                let result = Object.assign({}, link);
                if (index !== 0 && index !== linksLength){
                    result.text = result.text.slice(0, 3) + '...'
                }
                return result;
            });

            const shortlinksLength = this.getCharLength(shortlinks, arrowLength)
            if (shortlinksLength > maxSize){
                const excesses = shortlinksLength - maxSize;
                shortlinks[shortlinks.length-1].text = shortlinks[shortlinks.length-1].text.slice(0,-excesses).slice(0, -3) + '...'
            }
            return shortlinks;
        } else {
            return links;
        }
    }

    render() {
        const {children, breadcrumbConfig, subtitleLeft, titleKey} = this.props;
        const truncatedBreadcrumbs = this.truncateBreadcrumbs(breadcrumbConfig, BROKER_TRUNCATED_BREADCRUMB_ARROW_LENGTH, BROKER_TRUNCATED_BREADCRUMB_MAX_SIZE)
        return (
            <div className="broker-truncated-breadcrumb">
                <OKHeaderSubPage
                    subtitleLeft={subtitleLeft}
                    breadcrumbConfig={truncatedBreadcrumbs}
                    isSubtitleLeftCapital={false}
                    finalTitle={getFinalTitle(titleKey)}
                    subtitleNoEllipsis={true}
                >
                    {children}
                </OKHeaderSubPage>
            </div>
        )
    }
}

BrokerTruncatedBreadcrumb.propTypes = {
    breadcrumbConfig: PropTypes.array.isRequired,
    subtitleLeft: PropTypes.string,
    children: PropTypes.any,
    titleKey: PropTypes.string
};

module.exports = BrokerTruncatedBreadcrumb;